
export const getErrorMessage = (error) => {
  const hasReponseErrorMessage = error.response && error.response.data && error.response.data.message
  if (hasReponseErrorMessage) {
    return hasReponseErrorMessage
  }

  return error.message
}
